<div class="cm-template-tree-scene-node-info-tree-container">
    <cdk-tree [dataSource]="$dataSource()" [treeControl]="treeControl">
        <cdk-nested-tree-node *cdkTreeNodeDef="let node" class="cm-template-tree-scene-node-info-tree-node">
            <cm-template-tree-scene-node-info-tree-item [treeItem]="node" [infoTree]="this"> </cm-template-tree-scene-node-info-tree-item>
            @if ($hasChildren()(node)) {
                <div [class.cm-template-tree-scene-node-info-tree-invisible]="!treeControl.isExpanded(node)" class="cm-child-nodes">
                    <ng-container cdkTreeNodeOutlet></ng-container>
                </div>
            }
        </cdk-nested-tree-node>
    </cdk-tree>
</div>
